webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(12),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            dialRotation: 0,
            dragging: false,
            dragStartAngle: 0,
            rotateTimeout: 0,
            selectedOption: null,
            washOptions: {
                0: {
                    img: 'washoptions_stop.svg',
                    title: 'Stop',
                    content: 'Turns the pump off. Use this once you\'re done washing to save water.'
                },
                1: {
                    img: 'washoptions_tire.svg',
                    title: 'Tire Cleaner',
                    content: 'Removes grease and oil from tires'
                },
                2: {
                    img: 'washoptions_bug.svg',
                    title: 'Bug Off',
                    content: 'Dissolves bugs'
                },
                3: {
                    img: 'washoptions_presoak.svg',
                    title: 'Pre-Soak',
                    content: 'Pre-soaks your car'
                },
                4: {
                    img: 'washoptions_foam.svg',
                    title: 'Foam Brush',
                    content: 'Foamy soap with a brush'
                },
                5: {
                    img: 'washoptions_soap.svg',
                    title: 'High Pressure Soap',
                    content: 'Soap at high pressure, why not?'
                },
                6: {
                    img: 'washoptions_rinse.svg',
                    title: 'High Pressure Rinse',
                    content: 'Use good ol\' water to get that baked on dirt off!'
                },
                7: {
                    img: 'washoptions_wax.svg',
                    title: 'Wax',
                    content: 'Seal in that new car freshness by applying wax to your car body'
                },
                8: {
                    img: 'washoptions_clearcoat.svg',
                    title: 'Clear coat',
                    content: 'Seal in that new car freshness by applying clear coat to your car body'
                },
                9: {
                    img: 'washoptions_spotfree.svg',
                    title: 'Spot-free Rinse',
                    content: 'Soft water (water free from minerals and other contaminants), leaves little to no spots after rinsing with it'
                }
            },
            descriptions: {
                stop: 'Turns off the pump, saves water & saves the environment'
            }
        };
    },

    methods: {
        panStart: function panStart(e) {
            this.dragStartAngle = this.getCurrentAngle(e.center.x, e.center.y) - this.dialRotation;
            this.dragging = true;
        },
        handlePan: function handlePan(e) {
            if (this.dragging) {
                this.dialRotation = this.getCurrentAngle(e.center.x, e.center.y) - this.dragStartAngle;
            }
        },
        panStop: function panStop(e) {
            var _this = this;

            if (this.dragging) {
                var currentAngle = this.getCurrentAngle(e.center.x, e.center.y);
                this.dialRotation = currentAngle - this.dragStartAngle;
                this.dragging = false;

                var endRotate = function endRotate(target) {
                    clearTimeout(_this.rotateTimeout);
                    if (Math.abs(target) > 0.2) {
                        _this.dialRotation += target;
                        _this.rotateTimeout = setTimeout(function () {
                            endRotate(target - target / 10);
                        }, 10);
                    }
                };
                endRotate((currentAngle > 90 || currentAngle < -90 ? -e.velocity : e.velocity) * 5);
            }
        },
        getCurrentAngle: function getCurrentAngle(posX, posY) {
            var dial = this.$refs.dial.getBoundingClientRect();
            var windowX = dial.left + dial.width / 2;
            var windowY = dial.top + dial.height / 2;
            var mouseX = posX;
            var mouseY = posY;
            var angle = -Math.atan2(windowX - mouseX, windowY - mouseY) * (180 / Math.PI);
            return angle;
        },
        selectOption: function selectOption(option) {
            var _this2 = this;

            this.selectedOption = this.selectedOption !== null && this.selectedOption.img === this.washOptions[option].img ? null : this.washOptions[option];
            var rotateTo = -36 * option;
            if (rotateTo - this.dialRotation > 180) {
                this.dialRotation += 360;
            } else if (rotateTo - this.dialRotation < -180) {
                this.dialRotation -= 360;
            }

            var rotate = function rotate(target) {
                clearTimeout(_this2.rotateTimeout);
                var delta = _this2.dialRotation - target;
                if (Math.abs(delta) > 1) {
                    _this2.dialRotation -= Math.round(delta / 20 * 10) / 10;
                    _this2.rotateTimeout = setTimeout(function () {
                        rotate(target);
                    }, 4);
                } else {
                    clearTimeout(_this2.rotateTimeout);
                }
            };
            rotate(rotateTo);
        }
    }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_main_scss__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scss_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_touch__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_touch__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_touch___default.a);

var eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

if (typeof __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$bus === 'undefined') {
    Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, "$bus", {
        value: eventHub,
        enumerable: true,
        configurable: true
    });
}

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home.5fae8ba.png";

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/warriorhead.6cb20ac.svg";

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Choose from 9 different washes")]), _vm._v(" "), _c('v-touch', {
    ref: "dialbox",
    staticClass: "dial-container",
    attrs: {
      "pan-options": {
        direction: 'horizontal',
        threshold: 50
      }
    },
    on: {
      "panstart": _vm.panStart,
      "pan": _vm.handlePan,
      "panend": _vm.panStop
    }
  }, [_c('div', {
    ref: "dial",
    class: {
      'wash-dial': true, 'has-selected': _vm.selectedOption !== null
    }
  }, [_vm._l((_vm.washOptions), function(option, index) {
    return _c('v-touch', {
      key: index,
      class: {
        'wash-option': true, 'selected': _vm.selectedOption !== null && _vm.selectedOption.img === option.img
      },
      style: ({
        transform: 'rotate(' + ((36 * index) + _vm.dialRotation) + 'deg)'
      }),
      on: {
        "tap": function($event) {
          _vm.selectOption(index)
        }
      }
    }, [_c('div', {
      staticClass: "sticker",
      style: ({
        transform: 'rotate(' + (-_vm.dialRotation - (36 * index)) + 'deg)',
        'background-image': 'url(/static/' + option.img + ')'
      })
    })])
  }), _vm._v(" "), (_vm.selectedOption) ? _c('div', {
    staticClass: "wash-description"
  }, [_c('h3', [_vm._v(_vm._s(_vm.selectedOption.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.selectedOption.content))])]) : _vm._e()], 2)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("WARRIOR WASH!")]), _vm._v(" "), _c('div', {
    staticClass: "tagline"
  }, [_vm._v("Self Service Car Wash")])]), _vm._v(" "), _c('div', {
    staticClass: "head-content"
  }, [_c('img', {
    staticClass: "wash-image",
    attrs: {
      "src": __webpack_require__(9)
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n            309 Main St, Santa Rosa, TX 78593\n            "), _c('br'), _vm._v("\n            Open 24/7\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("$1.00 to start"), _c('br'), _vm._v("4 minute wash")]), _vm._v(" "), _c('img', {
    staticClass: "coins",
    attrs: {
      "src": __webpack_require__(8)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "coin",
    attrs: {
      "src": __webpack_require__(7)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "inline-text"
  }, [_vm._v("= 1 extra minute")])])
}]}

/***/ })
],[5]);


// WEBPACK FOOTER //
// static/js/app.660778b43d866ab2f7d7.js